// src/pages/FeedbackPage.js
import React, { useState } from 'react';
import SidebarLayout from '../components/SidebarLayout';

function FeedbackPage() {
  const [formData, setFormData] = useState({
    user_name: '',
    practice_name: '',
    user_role: '',
    duration: '',
    category: '',
    message: '',
    follow_up: false,
    email: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/send-feedback-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error('Failed to submit feedback');

      setFormData({
        user_name: '',
        practice_name: '',
        user_role: '',
        duration: '',
        category: '',
        message: '',
        follow_up: false,
        email: '',
      });

      alert('✅ Thank you! Your feedback has been submitted.');
    } catch (err) {
      alert('❌ There was an error submitting your feedback. Please try again.');
      console.error(err);
    }
  };

  return (
    <SidebarLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div
          style={{
            backgroundColor: '#f1f5f9',
            padding: '1rem 1.25rem',
            borderBottom: '1px solid #e2e8f0',
            fontSize: '1.125rem',
            fontWeight: 600,
            color: '#0f172a',
            borderTopLeftRadius: '0.5rem',
            borderTopRightRadius: '0.5rem',
            textAlign: 'center',
          }}
        >
          Submit Feedback
        </div>

        <div style={{ padding: '2rem', display: 'flex', justifyContent: 'center' }}>
          <form
            onSubmit={handleSubmit}
            style={{
              background: '#ffffff',
              padding: '1.25rem',
              borderRadius: '0.5rem',
              boxShadow: '0 0 10px rgba(0,0,0,0.05)',
              width: '100%',
              maxWidth: '550px',
              fontSize: '0.95rem',
              textAlign: 'left',
            }}
          >
            {[
              { label: 'Your Name (optional)', name: 'user_name', type: 'text' },
              { label: 'Practice Name (optional)', name: 'practice_name', type: 'text' },
            ].map(({ label, name, type }) => (
              <div key={name} style={{ marginBottom: '1.25rem' }}>
                <label style={{ display: 'block', fontWeight: '500', marginBottom: '0.25rem', color: '#1e293b' }}>
                  {label}
                </label>
                <input
                  type={type}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  style={{
                    width: '90%',
                    maxWidth: '480px',
                    borderRadius: '0.375rem',
                    border: '1px solid #cbd5e1',
                    fontSize: '0.9rem',
                    padding: '0.45rem 0.6rem',
                    display: 'block',
                  }}
                />
              </div>
            ))}

            {[
              {
                label: 'Your Role',
                name: 'user_role',
                options: ['', 'Front Office', 'Insurance Coordinator', 'Dentist', 'Clinical Team', 'Office Manager', 'Other'],
              },
              {
                label: 'How long have you used CovrIQ?',
                name: 'duration',
                options: ['', 'Less than 1 week', '1–2 weeks', 'More than 2 weeks'],
              },
              {
                label: 'Type of Feedback',
                name: 'category',
                options: [
                  '',
                  'Riq AI Behavior or Response Issue',
                  'Parsing Accuracy or Plan Data Error',
                  'User Interface or Page Layout Suggestion',
                  'Feature Request or Workflow Enhancement',
                  'Bug Report or Unexpected Error',
                  'General Comments or Praise',
                ],
              },
            ].map(({ label, name, options }) => (
              <div key={name} style={{ marginBottom: '1.25rem' }}>
                <label style={{ display: 'block', fontWeight: '500', marginBottom: '0.25rem', color: '#1e293b' }}>
                  {label}
                </label>
                <select
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  required={name === 'category'}
                  style={{
                    width: '90%',
                    maxWidth: '480px',
                    borderRadius: '0.375rem',
                    border: '1px solid #cbd5e1',
                    fontSize: '0.9rem',
                    padding: '0.45rem 0.6rem',
                    backgroundColor: '#fff',
                    display: 'block',
                  }}
                >
                  {options.map((opt, i) => (
                    <option key={i} value={opt}>
                      {opt === '' ? `Select ${label.split(' ')[0]}` : opt}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            <div style={{ marginBottom: '1.25rem' }}>
              <label style={{ display: 'block', fontWeight: '500', marginBottom: '0.25rem', color: '#1e293b' }}>
                Your Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                style={{
                  width: '90%',
                  maxWidth: '480px',
                  borderRadius: '0.375rem',
                  border: '1px solid #cbd5e1',
                  fontSize: '0.9rem',
                  padding: '0.45rem 0.6rem',
                  resize: 'vertical',
                  display: 'block',
                }}
              />
            </div>

            <div style={{ marginBottom: '1.25rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', fontWeight: '500', color: '#1e293b' }}>
                <input
                  type="checkbox"
                  name="follow_up"
                  checked={formData.follow_up}
                  onChange={handleChange}
                  style={{ marginRight: '0.5rem' }}
                />
                I’d like a follow-up
              </label>
            </div>

            {formData.follow_up && (
              <div style={{ marginBottom: '1.25rem' }}>
                <label style={{ display: 'block', fontWeight: '500', marginBottom: '0.25rem', color: '#1e293b' }}>
                  Your Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  style={{
                    width: '90%',
                    maxWidth: '480px',
                    padding: '0.5rem',
                    borderRadius: '0.375rem',
                    border: '1px solid #cbd5e1',
                    fontSize: '0.9rem',
                    display: 'block',
                  }}
                />
              </div>
            )}

            <button
              type="submit"
              style={{
                backgroundColor: '#3b82f6',
                color: 'white',
                padding: '0.5rem 1.5rem',
                borderRadius: '0.375rem',
                fontSize: '0.95rem',
                fontWeight: '600',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Submit Feedback
            </button>
          </form>
        </div>
      </div>
    </SidebarLayout>
  );
}

export default FeedbackPage;
